import { render, staticRenderFns } from "./PermissionAccordion.vue?vue&type=template&id=61e11f08"
import script from "./PermissionAccordion.vue?vue&type=script&lang=js"
export * from "./PermissionAccordion.vue?vue&type=script&lang=js"
import style0 from "./PermissionAccordion.vue?vue&type=style&index=0&id=61e11f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports